import { render, staticRenderFns } from "./ExerciseStatisticsDialog.vue?vue&type=template&id=2e94ca18&scoped=true"
import script from "./ExerciseStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./ExerciseStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./ExerciseStatisticsDialog.vue?vue&type=style&index=0&id=2e94ca18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94ca18",
  null
  
)

export default component.exports